import {useEffect, useRef} from "react";

import useRoutePermissions, {
  UI_PERMISSION_TYPE,
} from "../../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

function IndeterminateCheckbox({
  indeterminate,
  className = "",
  disabled,
  uiPermissionType = UI_PERMISSION_TYPE.WRITABLE,
  ...rest
}) {
  const {isDisabledByRoutePermission} = useRoutePermissions({uiPermissionType});

  const ref = useRef(null);

  useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      disabled={isDisabledByRoutePermission || disabled}
      className={className + " cursor-pointer"}
      {...rest}
    />
  );
}
export default IndeterminateCheckbox;
